import { render, staticRenderFns } from "./LimitReached.vue?vue&type=template&id=2c0b3925&scoped=true&"
import script from "./LimitReached.vue?vue&type=script&lang=js&"
export * from "./LimitReached.vue?vue&type=script&lang=js&"
import style0 from "./LimitReached.vue?vue&type=style&index=0&id=2c0b3925&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0b3925",
  null
  
)

export default component.exports